import React from 'react'

import { GetProducts } from '@web/walter-lib/api'
import { Card } from '../components/Card'
import s from './s.module.css'
import { useProducts } from '~api'

interface Props {
    onContinueClick: (product: GetProducts) => void
}

function Desktop({ onContinueClick }: Props) {
    const { data: productsData } = useProducts()

    return (
        <>
            <div className={s.desktopWrap}>
                <div className={s.desktopContent}>
                    {productsData?.products?.map(product => (
                        <Card key={product.id} data={product} onButtonClick={onContinueClick} type="tertiary" />
                    ))}
                </div>
            </div>
        </>
    )
}

export default Desktop
